import { useDataFastGoals } from "@/hooks/useDataFastGoals";
import { useTrackSection } from "@/hooks/useTrackSection";

/** Tempo mínimo na tela para uma seção contar como vista. */
const PERMANENCIA_MS = 1000;

/**
 * Marca a seção como vista uma vez por carregamento, e só depois de ela ficar
 * um segundo na tela.
 *
 * Os dois detalhes existem por causa do mesmo dado ruim. O botão do herói faz
 * `scrollIntoView({ behavior: "smooth" })` até os preços, e esse scroll
 * atravessa as onze seções da landing em cerca de um segundo. Sem `once` e sem
 * permanência, um único clique registrava onze `*_viewed` no mesmo segundo: o
 * painel mostrava alguém que leu a página inteira, quando a pessoa só pediu o
 * preço. Agora a travessia não conta nada — conta a seção onde ela parou.
 */
export function useSectionViewGoal(sectionName: string) {
  const { trackSectionViewed } = useDataFastGoals();

  return useTrackSection(() => trackSectionViewed(sectionName), {
    once: true,
    dwellMs: PERMANENCIA_MS,
  });
}
